import csn from "classnames";
import React from "react";
import css from "../index.module.less";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SpaceBetweenText = function SpaceBetweenText(props) {
  var leftText = props.leftText,
    rightText = props.rightText,
    className = props.className;
  return /*#__PURE__*/_jsxs("div", {
    className: csn(css.title_val_row, className),
    children: [/*#__PURE__*/_jsx("div", {
      className: css.title_val_row_title,
      children: leftText
    }), /*#__PURE__*/_jsx("div", {
      className: css.title_val_row_val,
      children: rightText
    })]
  });
};
export default SpaceBetweenText;